export function getPercentRating(voteAverage) {
  return Math.floor(voteAverage * 10);
}
